module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_CS-0164082aaeff4ee73564c4389ea0760b.svg";